/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useFormatDate = (options?: Intl.DateTimeFormatOptions) => {
  const { i18n } = useTranslation();

  const formatDate = useCallback(
    (date: string) => new Date(date).toLocaleDateString(i18n.language, options),
    [i18n.language, options],
  );

  return { formatDate };
};
